import React, { useEffect } from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Ro... Remove this comment to see the full error message
import { RouterHistory } from 'react-router';
import styled from 'styled-components';

import { Category, CmsTag } from 'api/cms';
import { CurrentUser } from 'api/currentUser';
import { PublicPage, Subsite } from 'api/website';
import AuthorCard from 'components/AuthorCard';
import Box from 'components/Box';
import { SecondaryButton } from 'components/Button';
import Byline from 'components/Byline';
import { CmsRecommendedJobsBlock } from 'components/Cms/RecommendedJobs';
import getContentBlock, { hasBackground } from 'components/Cms/getContentBlock';
import SocialButtons from 'components/CmsSocialButtons';
import Container from 'components/Container';
import { AnimatedCheckmark } from 'components/Icon';
import { FilestackImage } from 'components/Image';
import Spinner from 'components/Spinner';
import Tag from 'components/Tag';
import { BodySmall, H1 } from 'components/Text';
import SubscribeToSubsiteContainer from 'containers/SubscribeToSubsiteContainer';
import ContentLayout from 'layouts/ContentLayout';
import { colors } from 'theme';
import { trackClicked, trackPageView } from 'utils/analytics';
import { isNotEmpty } from 'utils/functional';

const Sidebar = styled.div`
  > * {
    &:not(:first-child) {
      margin-top: 40px;
    }
  }
`;
const HeaderImage = styled.div`
  img {
    width: 100%;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Categories = ({
  homePageUrl,
  categories,
}: {
  homePageUrl: string;
  categories: Array<Category>;
}) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    <Box data-qa-id="categories" display="flex" m="-6px" flexWrap="wrap">
      {categories.map((category) => (
        <Tag
          key={category.slug}
          component={homePageUrl && 'a'}
          disabled={!homePageUrl && 'disabled'}
          data-qa-id="category-link"
          href={
            homePageUrl ? `/${homePageUrl}?categories=${category.slug}&pq=` : ''
          }
          m="6px"
          large
        >
          {category.name}
        </Tag>
      ))}
    </Box>
  </>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Tags = ({
  homePageUrl,
  tags,
}: {
  homePageUrl: string;
  tags: Array<CmsTag>;
}) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    <Box data-qa-id="tags" display="flex" m="-6px">
      {tags.map((tag) => (
        <Tag
          key={tag.slug}
          component={homePageUrl && 'a'}
          disabled={!homePageUrl && 'disabled'}
          data-qa-id="tag-link"
          href={homePageUrl ? `/${homePageUrl}?tags.slug=${tag.slug}&pq=` : ''}
          m="6px"
        >
          {tag.tag}
        </Tag>
      ))}
    </Box>
  </>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ContentPage = ({
  isStaff,
  content,
  subsite,
  withBanner,
  fullWidthLayout,
  loggedIn,
  currentUser,
  pushFlashMessage,
  updateCurrentUser,
  pageUrl,
  locale,
  homePageUrl,
  history,
  hasGradProgram,
  showListingCounts,
  gMapsErrored,
  setExposeSiteNav,
}: {
  isStaff: boolean;
  content: PublicPage;
  subsite: Subsite;
  withBanner?: boolean;
  fullWidthLayout?: boolean;
  loggedIn: boolean;
  currentUser: CurrentUser | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pushFlashMessage: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateCurrentUser: (...args: Array<any>) => any;
  pageUrl: string;
  locale: string;
  homePageUrl: string;
  history: RouterHistory;
  hasGradProgram: boolean;
  showListingCounts: boolean;
  gMapsErrored: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setExposeSiteNav: (...args: Array<any>) => any;
}) => {
  useEffect(() => {
    trackPageView('CMS Page', {
      subsite_name: subsite.publicName,
      page_title: content.title,
      page_type: content.type,
      categories: content.categories.map((category) => category.name),
    });
  }, [content, subsite.publicName]);
  const offsetAnchors = content.contentBlocks.some(
    (block) =>
      block.type === 'STICKY_HEADER_LINKS_GRAD' ||
      block.type === 'STICKY_HEADER_LINKS'
  );
  const firstBlock = content.contentBlocks[0];
  const lastBlock = content.contentBlocks[content.contentBlocks.length - 1] || {
    type: undefined,
  };
  const header =
    (content.contentBlocks &&
      content.contentBlocks.length > 0 &&
      (['GRAD_CTA_HERO', 'CTA_HERO', 'DONATE'].includes(firstBlock.type) ||
        (firstBlock.type === 'SPLIT_CONTENT' &&
          firstBlock.data.appearance === 'FULL_WIDTH'))) ||
    content.heroSearch ||
    !content.showTitle ? undefined : (
      <>
        {content.type === 'POST' &&
          content.categories &&
          content.categories.length > 0 && (
            <Box mb={24}>
              <Categories
                categories={content.categories}
                homePageUrl={
                  content.subsite.homePage && content.subsite.homePage.url
                }
              />
            </Box>
          )}
        <H1 m="0" textAlign={fullWidthLayout ? 'center' : 'left'}>
          {content.title}
        </H1>
        {(content.author || (content.postedDate && content.showDate)) && (
          <Box mt={4}>
            <Byline
              slug={content.author ? content.author.slug : undefined}
              name={content.author ? content.author.name : undefined}
              imageHandle={
                content.author && content.author.image
                  ? content.author.image.handle
                  : undefined
              }
              homePageUrl={
                content.subsite.homePage && content.subsite.homePage.url
              }
              postedDate={content.postedDate}
              showDate={content.showDate}
            />
          </Box>
        )}
      </>
    );
  let firstRealBlockIndex;
  content.contentBlocks.forEach((block, i) => {
    if (!firstRealBlockIndex && block.type !== 'SCROLL_TRACKING') {
      firstRealBlockIndex = i;
    }
  });

  const getPrevRealBlock = (blocks, i) => {
    let block;
    let j = i;

    const setBlock = () => {
      j -= 1;
      block = blocks[j];
    };

    setBlock();

    while (block && block.type === 'SCROLL_TRACKING') {
      setBlock();
    }

    return block;
  };

  const { listingCounts } = content.heroSearch || {};

  return (
    <ContentLayout
      listingCounts={listingCounts}
      isStaff={isStaff}
      layout={content.layout}
      fullWidthLayout={fullWidthLayout}
      padTop={
        isNotEmpty(content.contentBlocks) &&
        !(
          [
            'STICKY_HEADER_LINKS',
            'STICKY_HEADER_LINKS_GRAD',
            'CTA_HERO',
            'GRAD_CTA_HERO',
            'IDEALIST_DAYS_MAP',
            'DONATE',
            'SIGN_UP',
            'SCROLL_TRACKING',
          ].includes(firstBlock.type) ||
          (firstBlock.type === 'SPLIT_CONTENT' &&
            ['FULL_WIDTH', 'OVERLAPPING'].includes(
              firstBlock.data.appearance
            )) ||
          hasBackground({
            block: firstBlock,
            fullWidthLayout,
          })
        )
      }
      padBottom={
        !['CTA_HERO', 'GRAD_CTA_HERO', 'SPLIT_CONTENT'].includes(lastBlock.type)
      }
      headerImage={
        content.headerImage && (
          <HeaderImage>
            <FilestackImage
              data-qa-id="cms-page-header-image"
              data={content.headerImage}
              width={fullWidthLayout ? 1152 : 952}
              alt={
                content.headerImage.altText
                  ? content.headerImage.altText
                  : content.title
              }
            />
            {content.headerImage.caption && (
              <BodySmall color={colors.battleshipGrey} mt="8px">
                {content.headerImage.caption}
              </BodySmall>
            )}
          </HeaderImage>
        )
      }
      header={header}
      socialButtons={
        content.hasSocialSharing && (
          <SocialButtons
            content={content}
            message={content.metaDescription}
            title={content.title}
            subsite={subsite.publicName}
          />
        )
      }
      subscribeButton={
        subsite.canSubscribe &&
        content.type === 'POST' && (
          <Box m="6px">
            {/* @ts-expect-error ts-migrate(2786) FIXME: 'SubscribeToSubsiteContainer' cannot be used as a ... Remove this comment to see the full error message */}
            <SubscribeToSubsiteContainer
              subsiteId={subsite.id}
              render={({ subscribe, isSubscribed, submitting }) => (
                <Box
                  component={SecondaryButton}
                  classes={['flex', 'align-center', 'justify-center']}
                  height={32}
                  minWidth={132}
                  size="small"
                  onClick={() => {
                    subscribe();
                    trackClicked('Subscribe', {
                      context: 'CMS Page',
                    });
                  }}
                  data-qa-id="subscribe-to-subsite"
                  disabled={isSubscribed}
                >
                  {currentUser && currentUser.isLoaded && !submitting ? (
                    <>
                      {isSubscribed && (
                        <AnimatedCheckmark
                          mr="8px"
                          stroke={colors.turtleGreen}
                        />
                      )}
                      {isSubscribed
                        ? getText('Subscribed!')
                        : getText('Subscribe')}
                    </>
                  ) : (
                    <Spinner size="small" label="Submitting" />
                  )}
                </Box>
              )}
            />
          </Box>
        )
      }
      showListingCounts={showListingCounts}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ id: string; type: "IMAGE" | "RICHTEXT" | ... Remove this comment to see the full error message
      blocks={content.contentBlocks
        .map((block, index) => {
          const prevBlock = getPrevRealBlock(content.contentBlocks, index);
          return block.type === 'ANCHOR'
            ? {
                component: null,
                id: block.id,
                type: block.type,
                width: 'FULL',
                padding: 'DEFAULT',
                mustNotHaveDivider: true,
                hasBackground: false,
              }
            : getContentBlock({
                content,
                blocks: content.contentBlocks,
                index,
                block,
                loggedIn,
                currentUser,
                pushFlashMessage,
                updateCurrentUser,
                pageUrl,
                locale,
                subsite,
                history,
                hasGradProgram,
                isSidebar: false,
                isPageHeader: !withBanner && firstRealBlockIndex === index,
                homePageUrl,
                pageUpdated: content.updated,
                fullWidthLayout,
                anchor:
                  index > 0 && prevBlock && prevBlock.type === 'ANCHOR'
                    ? prevBlock
                    : undefined,
                offsetAnchors,
                gMapsErrored,
                setExposeSiteNav,
              });
        })
        .filter((b) => b.type !== 'ANCHOR')}
      belowBlocks={
        (content.hasRecommendedJobs ||
          (content.tags && content.tags.length > 0) ||
          content.author) && (
          <>
            {content.tags && content.tags.length > 0 && (
              <Box mb={32}>
                <Tags
                  homePageUrl={
                    content.subsite.homePage && content.subsite.homePage.url
                  }
                  tags={content.tags}
                />
              </Box>
            )}
            {content.author && (
              <AuthorCard
                author={content.author}
                homePageUrl={homePageUrl}
                postedDate={content.postedDate}
                showDate={content.showDate}
                fullWidthLayout={fullWidthLayout}
              />
            )}
            {content.hasRecommendedJobs && (
              <CmsRecommendedJobsBlock
                data={{
                  headline: content.recommendedJobsHeadline,
                  layout: 'REGULAR',
                  jobFunction: undefined,
                }}
                currentUser={currentUser}
                history={history}
              />
            )}
          </>
        )
      }
      upperSidebar={
        content.sidebar &&
        content.sidebar.contentBlocksTop.length > 0 && (
          <Sidebar>
            {content.sidebar.contentBlocksTop.map((block, index) => (
              <Container key={block.id}>
                {
                  getContentBlock({
                    content,
                    block,
                    index,
                    loggedIn,
                    currentUser,
                    pushFlashMessage,
                    updateCurrentUser,
                    pageUrl,
                    locale,
                    subsite,
                    history,
                    hasGradProgram,
                    isSidebar: true,
                    homePageUrl,
                    pageUpdated: content.updated,
                    gMapsErrored,
                    setExposeSiteNav,
                  }).component
                }
              </Container>
            ))}
          </Sidebar>
        )
      }
      lowerSidebar={
        content.sidebar &&
        content.sidebar.contentBlocksBottom.length > 0 && (
          <Sidebar>
            {content.sidebar.contentBlocksBottom.map((block, index) => (
              <Container key={block.id}>
                {
                  getContentBlock({
                    content,
                    block,
                    index,
                    loggedIn,
                    currentUser,
                    pushFlashMessage,
                    updateCurrentUser,
                    pageUrl,
                    locale,
                    subsite,
                    history,
                    hasGradProgram,
                    isSidebar: true,
                    homePageUrl,
                    pageUpdated: content.updated,
                    gMapsErrored,
                    setExposeSiteNav,
                  }).component
                }
              </Container>
            ))}
          </Sidebar>
        )
      }
    />
  );
};

export default ContentPage;
